<template>
  <main>

    <b-modal id="modalcheckTr" v-model="formModal" ok-only centered :title="modalTitle">
      <p v-if="formStatus === 'success'" class="lead text-success">
        {{$t('message.ttvs') }}
      </p>
      <p v-else-if="formStatus === 'ratelimit'" class="lead text-warning">
        {{ $t('message.ttvrl') }}
      </p>
      <p v-else-if="formStatus === 'recaptcha_failed'" class="lead text-warning">
      {{ $t('message.ttvrc') }}
        <a href="mailto:customer-support@safetravel.today" class="text-warning font-weight-bold"> customer-support@safetravel.today</a>
      </p>
      <p v-else class="lead text-danger">
        {{$t('message.ttvf') }}
        <a href="mailto:customer-support@safetravel.today" class="text-warning font-weight-bold"> customer-support@safetravel.today</a>
      </p>
    </b-modal>

    <div id="ContactContainer" class="container-fluid px-0">
      <b-row>
        <b-col cols="12">
          <div class="custom_page_header">
            <h2>{{$t('message.affiliate_program_join')}}</h2>
            <p class="lead">{{$t('message.affiliate_program_byjoin')}}</p>
          </div>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col cols="12">
          <h2 class="savetravellocdetails">{{$t('message.earn_rewards')}}</h2>
          <p class="text-secondary">{{$t('message.personal_referral')}}</p>
          <ul class="checklisttype">
            <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" />{{$t('message.freetojoin')}}</li>
            <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" />{{$t('message.personal_link')}}</li>
            <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" />{{$t('message.ptravelagencies')}}</li>
            <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" />{{$t('message.commission_based')}}</li>
            <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" />{{$t('message.track_earnings')}}</li>
            <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" />{{$t('message.successful_referral')}}</li>
            <li><font-awesome-icon class="dbcheck" icon="fa-solid fa-check-double" size="lg" />{{$t('message.powerbysompo')}}</li>
          </ul>
          <p class="text-secondary">{{$t('message.areyouabusiness')}} → <a href="https://erp.safetravel.today" target="_blank" class="btn btn-sm btn-outline-secondary">erp.safetravel.today</a></p>
        </b-col>
      </b-row>
      <b-row class="mb-4">
          <b-col cols="12" class="mt-1">
            <!-- Contact Form -->
            <b-row class="justify-content-center">
              <b-col  
                  lg="8"
                  md="10"
                  sm="12">
                <form @submit.prevent="submit">
                  <fieldset class="form-fieldset">
                    <legend>{{$t('message.company_info')}}</legend>
                    <p class="text-secondary small">{{$t('message.sft_contact_ifcontusoon')}}</p>
                    <div class="control-group form-group">
                      <div class="controls">
                        <label>{{$t('message.company_name')}}:</label>
                        <input type="text" class="form-control" name="company_name" v-model="formData.company_name" minlength="4" required :placeholder='$t(`message.company_name_placeholder`)'>
                      </div>
                    </div>
                    <div class="control-group form-group">
                      <div class="controls">
                        <label>{{$t('message.company_email')}}</label>
                        <input type="email" class="form-control" name="company_email" v-model="formData.company_email" minlength="10" required :placeholder='$t(`message.sft_contact_placehomail`)'>
                      </div>
                    </div>
                    <div class="control-group form-group">
                      <div class="controls">
                        <label>{{$t('message.telephone')}}</label>
                        <input type="tel" class="form-control" name="company_phone" v-model="formData.company_phone" pattern=".{6,}" required :placeholder='$t(`message.sft_contact_placehophone`)' onkeyup="this.value=this.value.replace(/([^+0-9]+)/gi, '')">
                      </div>
                    </div>
                    <div class="control-group form-group">
                      <div class="controls">
                        <label>{{$t('message.contact_person')}}</label>
                        <input type="text" class="form-control" name="company_contact_person" v-model="formData.company_contact_person" minlength="6" required :placeholder='$t(`message.sft_contact_person_placeholder`)'>
                      </div>
                    </div>
                    <button type="submit" id="submit" class="btn btn-secondary" :disabled="isSubmitting">{{$t('message.sft_contact_sentmessage')}}</button>
                    <small class="mt-2 recatext">
                      This site is protected by reCAPTCHA and the Google
                      <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                      <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
                    </small>
                  </fieldset>
                </form>
              </b-col>
            </b-row>
          </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
import {
  BRow, BCol, BModal
} from 'bootstrap-vue'
import { formSubmitMixin } from '@/products';
export default {
  mixins: [formSubmitMixin],
  components: {
    BRow,
    BCol,
    BModal
  },
  metaInfo: {
  title: 'Affiliate Program | Safetravel.today - Making Travel Insurance Easy',
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { 
      name: 'description', 
      content: 'Join the Safetravel.today Affiliate Program and earn commissions by promoting trusted travel insurance plans. Sign up easily with our online form.' 
    },
    { 
      name: 'keywords', 
      content: 'travel insurance affiliate, affiliate program, earn commissions, partner with Safetravel.today, join affiliate' 
    },
    { property: 'og:title', content: 'Safetravel.today Affiliate Program' },
    { property: 'og:description', content: 'Become a Safetravel.today affiliate partner. Promote travel insurance plans and earn commissions with every sale. Easy signup form available.' },
    { property: 'og:image', content: 'https://safetravel.today/images/affiliate.png' },
    { property: 'og:type', content: 'website' },
    { name: 'robots', content: 'index, follow' },
  ],
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Safetravel.today',
          url: 'https://safetravel.today',
          logo: 'https://safetravel.today/logo.png',
          sameAs: [
            'https://www.facebook.com/safetraveltoday',
            'https://www.linkedin.com/company/safe-travel',
            'https://x.com/safetraveltoday'
          ],
          description: 'Safetravel.today is a travel insurance company offering secure, flexible, and affordable coverage for safe journeys worldwide.'
        },
      },
    ],
  },
  data() {
    return {
      formData: {
        company_name: '',
        company_email:'',
        company_phone:'',
        company_contact_person:'',
      }
    }
  },
  methods: {
    submit() { this.submitForm('affiliate') }
  },
}
</script>
<style scoped>
.checklisttype {
    list-style: none;
    padding: 0;
}
.checklisttype li {
    padding-left: 1.3em;
    padding-bottom: 0.5em;
    color: var(--foreground-color);
}
.dbcheck {
    margin-left: -1.3em;
    width: 1.3em;
    color: var(--accent3-color);
}
.form-fieldset {
  border: 1px solid var(--success-color);
  border-radius: 8px;
  padding: 0 30px 20px 30px;
}

.form-fieldset legend {
  color: var(--success-color);
  font-weight: 600;
  font-size: 1.5rem;
  padding: 0 10px;
  width: auto;
}
.recatext {
  color:var(--foreground-color);
  display:block;
  font-weight:500;
}
.recatext > a {
  font-weight: 700;
  color: var(--foreground-color);
  transition: color 0.3s ease, text-shadow 0.3s ease;
}
.recatext > a:hover {
  color: var(--primary-color);
  text-shadow: 0 0 8px rgba(var(--primary-color-rgb), 0.4);
}
</style>